import React, { useState, useEffect } from 'react'
import styles from './styles'
import {
  Autocomplete,
  withStyles,
  TextField,
  Typography,
  Checkbox,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  InputBase,
} from '@material-ui/core'
import { useSelector } from 'react-redux'
import { teamListAction } from 'src/reducers/teams/action'
import { useDispatch } from 'react-redux'
import { Icon } from '@iconify/react'
import { CoreButton } from '../core'
import { messageBoxHideAction } from 'src/reducers/message-box/action'
import { PatchContent, PatchData } from 'src/model/patch'
import { patchCollectionSettingsAction } from 'src/reducers/collection/action'
import { collectionMemberFilterAction } from 'src/reducers/teams/action'
const BootstrapInput = withStyles(theme => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(1),
    },
    '.MuiSvgIcon-root': {
      display: 'none',
    },
  },
  input: {
    borderRadius: 8,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: '1px solid #ced4da',
    fontSize: 16,
    padding: '10px 26px 10px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    '&:focus': {
      borderRadius: 4,
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
}))(InputBase)

const BootstrapInputLabel = withStyles(theme => ({
  root: {
    zIndex: 400,
    top: 0,
    left: 10,
    '&.Mui-focused': {
      display: 'none',
    },
    '&.MuiInputLabel-shrink': {
      display: 'none',
    },
  },
}))(InputLabel)

const BootstrapSelect = withStyles(theme => ({
  icon: {
    right: 8,
  },
}))(Select)

const CustomizedCheckBox = withStyles({
  root: {
    color: '#637381',
    '&$checked': {
      color: '#37D768',
    },
  },
  checked: {},
})(props => <Checkbox color="default" {...props} />)

const CollectionSelectionModal = props => {
  const { classes, id } = props
  const dispatch = useDispatch()
  const [selectedTeamList, setSelectedTeamList] = useState([])
  const collectionSettings = useSelector(
    state => state.collection.collectionSettings,
  )
  const [teamsList, setTeamsList] = useState([])
  useEffect(() => {
    dispatch(teamListAction({}, response => {}))
    if (collectionSettings && collectionSettings.teams) {
      const defaultTeams = collectionSettings.teams.filter(
        x => x.default !== true,
      )

      setSelectedTeamList(defaultTeams)
    }
  }, [dispatch, collectionSettings])

  const teamList = useSelector(state => state.teamsList.teamList)

  useEffect(() => {
    if (teamList && teamList.length > 0) {
      setTeamsList(teamList.filter(x => x.default !== true))
    }
  }, [teamList])

  const handleChange = event => {
    const newItemId = event.target.value[event.target.value.length - 1]
    const item = teamList.find(item => item.id === newItemId)

    if (selectedTeamList.some(selectedItem => selectedItem.id === newItemId)) {
      // If item is already selected, remove it
      setSelectedTeamList(
        selectedTeamList.filter(selectedItem => selectedItem.id !== newItemId),
      )
    } else {
      // If item is not selected, add it
      setSelectedTeamList([...selectedTeamList, item])
    }
  }

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 300,
        width: 250,
      },
    },
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left',
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left',
    },
    getContentAnchorEl: null,
  }
  const handleDone = () => {
    const patchSource = new PatchData(null, id)
    const defaultTeams = collectionSettings.teams.filter(
      x => x.default === true,
    )
    const newTeamsWithIds = [...selectedTeamList, ...defaultTeams]
    patchSource.addContent(
      new PatchContent(newTeamsWithIds, 'teams', PatchData.OPERATION_REPLACE),
    )
    let newQuery = {
      CurrentPage: 0,
      PageSize: 20,
      SortingColumn: 'id',
      FilterText: '',
      Filters: [],
      Id: id,
    }

    dispatch(
      patchCollectionSettingsAction(patchSource, response => {
        dispatch(collectionMemberFilterAction(id, newQuery, () => {}))

        dispatch(messageBoxHideAction())
      }),
    )
  }
  const handleCancel = () => {
    dispatch(messageBoxHideAction())
  }
  return (
    <div>
      {teamsList && teamsList[0] != undefined ? (
        <FormControl variant="standart" className={classes.formControl}>
          <BootstrapInputLabel htmlFor="mutiple-chip">
            Select Group
          </BootstrapInputLabel>
          <BootstrapSelect
            multiple
            id="mutiple-chip"
            value={selectedTeamList}
            onChange={handleChange}
            input={<BootstrapInput id="select-multiple-chip" />}
            className={classes.select}
            renderValue={selected => (
              <div className={classes.chips}>
                <Typography>
                  {selectedTeamList.length} Groups Selected
                </Typography>
              </div>
            )}
            MenuProps={MenuProps}
          >
            {teamsList.map((item, index) => {
              return (
                <MenuItem
                  key={item.name}
                  name={item.id}
                  value={item.id}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                  }}
                >
                  <div>
                    <CustomizedCheckBox
                      checked={selectedTeamList
                        .map(listItem => listItem.id)
                        .includes(item.id)}
                    />
                    {item.name}
                  </div>
                  <div className={classes.displayFAI}>
                    <Icon icon={'mdi:people'} color="#637381" />
                    <Typography
                      fontSize={'12px'}
                      fontWeight={400}
                      color={'#637381'}
                    >
                      {item.memberCount}
                    </Typography>
                  </div>
                </MenuItem>
              )
            })}
          </BootstrapSelect>
        </FormControl>
      ) : (
        <Typography>No groups available</Typography>
      )}

      {selectedTeamList && selectedTeamList[0] != undefined && (
        <div
          style={{
            maxHeight: '50vh',
            overflowY: 'auto',
          }}
        >
          <div className={classes.infoTextForGroup}>
            <Typography fontSize={13}>Groups that can be access:</Typography>
          </div>

          {selectedTeamList.map((item, index) => {
            return (
              <div
                key={item.id}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  marginBottom: '8px',
                  padding: '12px 16px',
                  borderRadius: '8px',
                  backgroundColor: '#F4F6F8',
                }}
              >
                <Typography fontSize={'14px'} fontWeight={500}>
                  {item.name}
                </Typography>
                <div
                  style={{ display: 'flex', alignItems: 'center', gap: '4px' }}
                >
                  <Typography fontSize={'14px'} fontWeight={600}>
                    {item.memberCount}
                  </Typography>
                  <Typography
                    fontSize={'12px'}
                    fontWeight={400}
                    color={'#637381'}
                  >
                    Learners
                  </Typography>
                </div>
              </div>
            )
          })}
        </div>
      )}
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '8px',
          marginTop: '16px',
        }}
      >
        <CoreButton variant="outlined" color="secondary" onClick={handleCancel}>
          Cancel
        </CoreButton>
        <CoreButton variant="contained" color="primary" onClick={handleDone}>
          Done
        </CoreButton>
      </div>
    </div>
  )
}

export default withStyles(styles)(CollectionSelectionModal)
